// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__1IF+k","l4":"styles_l4__3XQpp","redir":"styles_redir__tlgGg"};